// extracted by mini-css-extract-plugin
export default {"cardFlexCol":"CardFlexCol_cardFlexCol__bbOG6"};